import { createSlice } from '@reduxjs/toolkit';
import { selectsApi } from '@store/rtk/selects';
import { selectAdditionalItemType, selectItemType } from '@src/types';
import { authLoginApi, membersApi, notesApi, payorsApi } from '@store/rtk';
import { sortByLabelAsc } from '@utils/helpers';
import { getOrderedLosOptions } from '@utils/los';

type InitialStateSliceType = {
  statusSelectData: Array<selectItemType> | null;
  modeOfTransportAllTypes: Array<selectItemType> | null;
  modeOfTransportSelectData: Array<selectItemType> | null;
  businessTypes: Array<selectItemType> | null;
  categoryTypes: Array<selectItemType> | null;
  rideServiceCategoryTypes: Array<selectItemType> | null;
  servicesTypes: Array<selectItemType> | null;
  noteCategory: Array<selectItemType> | null;
  addon: Array<selectItemType> | null;
  markUpType: Array<selectItemType> | null;
  billQualifier: Array<selectItemType> | null;
  genders: Array<selectItemType> | null;
  spokenLanguages: Array<selectItemType> | null;
  methodVerifications: Array<selectItemType> | null;
  vehicleModels: Array<selectItemType> | null;
  vehicleMakes: Array<selectItemType> | null;
  vehicleColors: Array<selectItemType> | null;
  vehicleTypes: Array<selectItemType> | null;
  vehicleStatus: Array<selectItemType> | null;
  vehicleRegistrationIssuingAuthority: Array<selectItemType> | null;
  vehicleInspectionType: Array<selectItemType> | null;
  vehicleInspectionOrganization: Array<selectItemType> | null;
  vehicleInspectionDetermination: Array<selectItemType> | null;
  vehiclePermitIssuingAuthority: Array<selectItemType> | null;
  personnelIdentificationType: Array<selectItemType> | null;
  personnelIdentificationIssuing: Array<selectItemType> | null;
  personnelCertificationType: Array<selectItemType> | null;
  personnelCertificationIssuing: Array<selectItemType> | null;
  personnelScreeningType: Array<selectItemType> | null;
  personnelScreeningsIssuing: Array<selectItemType> | null;
  personnelPermitType: Array<selectItemType> | null;
  personnelPermitIssuing: Array<selectItemType> | null;
  contractorsType: Array<selectItemType> | null;
  contractorsAtms: Array<selectItemType> | null;
  contractorsStatus: Array<selectItemType> | null;
  relationshipSelect: Array<selectItemType> | null;
  insuranceType: Array<selectItemType> | null;
  insuranceInsurer: Array<selectItemType> | null;
  insuranceBroker: Array<selectItemType> | null;
  contractType: Array<selectItemType> | null;
  licenseType: Array<selectItemType> | null;
  permitInsuranceType: Array<selectItemType> | null;
  userType: Array<selectItemType> | null;
  surveyTemplateSelect: Array<selectItemType> | null;
  personnelItemTypeSelect: Array<selectItemType> | null;
  personnelItemStatusSelect: Array<selectItemType> | null;
  preferenceAllTags: Array<selectItemType> | null;
  preferenceSelectedTags: Array<selectItemType> | null;
  placesLocationTypes: Array<selectItemType> | null;
  limitsTypes: Array<selectItemType> | null;
  memberInfoPriority: Array<selectItemType> | null;
  verificationMethods: Array<selectItemType> | null;
  sendingMethods: Array<selectItemType> | null;
  warningMethods: Array<selectItemType> | null;
  contractors: Array<selectItemType> | null;
  lobContractors: Array<selectItemType> | null;
  activeContractors: Array<selectItemType> | null;
  activeContractorsV2: Array<selectItemType> | null;
  contractorsLos: Array<selectItemType> | null;
  contractorServices: Array<selectItemType> | null;
  levelOfService: Array<selectItemType> | null;
  timeSelect: Array<selectItemType> | null;
  placeLocationsSelect: Array<selectItemType> | null;
  payorSelectData: Array<selectItemType> | null;
  levelOfServiceAdditional: Array<selectAdditionalItemType> | null;
  healthPlanSelectDate: Array<selectAdditionalItemType> | null;
  userTypeFiltration: Array<selectAdditionalItemType> | null;
  userPermissionsFiltration: Array<selectItemType> | null;
  createdByFiltration: Array<selectAdditionalItemType> | null;
  changedByFiltration: Array<selectAdditionalItemType> | null;
  viewedByFiltration: Array<selectAdditionalItemType> | null;
  notedByFiltration: Array<selectAdditionalItemType> | null;
  rideSegmentStatus: Array<selectAdditionalItemType> | null;
  rideSegmentStatusChange: Array<selectAdditionalItemType> | null;
  statusReasons: Array<selectAdditionalItemType> | null;
  userPermissionsTypeSelect: Array<selectAdditionalItemType> | null;
  userPermissionsSelect: Array<selectAdditionalItemType> | null;
  contractorsLosAllType: Array<selectAdditionalItemType> | null;
  preferenceActiveContractors: Array<selectAdditionalItemType> | null;
  preferenceAssignmentTypes: Array<selectAdditionalItemType> | null;
  dashboardContractors: Array<selectAdditionalItemType> | null;
  activityStatus: Array<selectItemType> | null;
  notificationMethods: Array<selectItemType> | null;
};

const initialState: InitialStateSliceType = {
  statusSelectData: null,
  modeOfTransportAllTypes: null,
  modeOfTransportSelectData: null,
  businessTypes: null,
  categoryTypes: null,
  servicesTypes: null,
  rideServiceCategoryTypes: null,
  noteCategory: null,
  addon: null,
  markUpType: null,
  billQualifier: null,
  genders: null,
  spokenLanguages: null,
  methodVerifications: null,
  vehicleModels: null,
  vehicleMakes: null,
  vehicleColors: null,
  vehicleTypes: null,
  vehicleStatus: null,
  vehicleRegistrationIssuingAuthority: null,
  vehicleInspectionType: null,
  vehicleInspectionOrganization: null,
  vehicleInspectionDetermination: null,
  vehiclePermitIssuingAuthority: null,
  personnelIdentificationType: null,
  personnelIdentificationIssuing: null,
  personnelCertificationType: null,
  personnelCertificationIssuing: null,
  personnelScreeningType: null,
  personnelScreeningsIssuing: null,
  personnelPermitType: null,
  personnelPermitIssuing: null,
  contractorsType: null,
  contractorsAtms: null,
  contractorsStatus: null,
  relationshipSelect: null,
  insuranceType: null,
  insuranceInsurer: null,
  insuranceBroker: null,
  contractType: null,
  licenseType: null,
  permitInsuranceType: null,
  userType: null,
  surveyTemplateSelect: null,
  personnelItemTypeSelect: null,
  personnelItemStatusSelect: null,
  preferenceAllTags: null,
  preferenceSelectedTags: null,
  placesLocationTypes: null,
  limitsTypes: null,
  memberInfoPriority: null,
  verificationMethods: null,
  sendingMethods: null,
  warningMethods: null,
  contractors: null,
  lobContractors: null,
  activeContractors: null,
  activeContractorsV2: null,
  contractorsLos: null,
  contractorServices: null,
  levelOfService: null,
  timeSelect: null,
  placeLocationsSelect: null,
  payorSelectData: null,
  levelOfServiceAdditional: null,
  healthPlanSelectDate: null,
  userTypeFiltration: null,
  userPermissionsFiltration: null,
  changedByFiltration: null,
  createdByFiltration: null,
  viewedByFiltration: null,
  notedByFiltration: null,
  rideSegmentStatus: null,
  rideSegmentStatusChange: null,
  statusReasons: null,
  userPermissionsTypeSelect: null,
  userPermissionsSelect: null,
  contractorsLosAllType: null,
  preferenceActiveContractors: null,
  preferenceAssignmentTypes: null,
  activityStatus: null,
  dashboardContractors: null,
  notificationMethods: null,
};

export const selectsSlice = createSlice({
  name: 'selects',
  initialState,
  reducers: {
    setLevelOfServiceAdditional: (state, { payload }) => {
      state.levelOfServiceAdditional = payload;
    },
    setContractorServices: (state, { payload }) => {
      state.contractorServices = payload;
    },
    setActivityStatus: (state, { payload }) => {
      state.activityStatus = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        selectsApi.endpoints.getAgreementsStatus.matchFulfilled,
        (state, { payload }) => {
          state.statusSelectData = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getModeOfTransportAllTypes.matchFulfilled,
        (state, { payload }) => {
          state.modeOfTransportAllTypes = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getModeOfTransportSelectData.matchFulfilled,
        (state, { payload }) => {
          if (payload) {
            state.modeOfTransportSelectData = payload;
          }
        }
      )
      .addMatcher(
        selectsApi.endpoints.getBusinessTypes.matchFulfilled,
        (state, { payload }) => {
          if (payload) {
            state.businessTypes = payload;
          }
        }
      )
      .addMatcher(
        selectsApi.endpoints.getCategoryTypes.matchFulfilled,
        (state, { payload }) => {
          state.categoryTypes = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getRideServiceCategoryTypes.matchFulfilled,
        (state, { payload }) => {
          state.rideServiceCategoryTypes = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getServicesTypes.matchFulfilled,
        (state, { payload }) => {
          state.servicesTypes = payload;
        }
      )
      .addMatcher(
        notesApi.endpoints.getNoteCategories.matchFulfilled,
        (state, { payload }) => {
          if (Array.isArray(payload)) {
            state.noteCategory = payload ?? [];
          } else {
            state.noteCategory = payload ? [payload] : [];
          }
        }
      )
      .addMatcher(
        notesApi.endpoints.getNoteCategories.matchPending,
        (state, { payload }) => {
          state.noteCategory = [];
        }
      )
      .addMatcher(
        notesApi.endpoints.getNoteCategoriesForModal.matchFulfilled,
        (state, { payload }) => {
          if (Array.isArray(payload)) {
            state.noteCategory = payload ?? [];
          } else {
            state.noteCategory = payload ? [payload] : [];
          }
        }
      )
      .addMatcher(
        selectsApi.endpoints.getEquipmentAndAddon.matchFulfilled,
        (state, { payload }) => {
          state.addon = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getMarkUpType.matchFulfilled,
        (state, { payload }) => {
          state.markUpType = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getBillQualifierType.matchFulfilled,
        (state, { payload }) => {
          state.billQualifier = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getGenderSelectData.matchFulfilled,
        (state, { payload }) => {
          state.genders = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getSpokenLanguages.matchFulfilled,
        (state, { payload }) => {
          state.spokenLanguages = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getMethodVerifications.matchFulfilled,
        (state, { payload }) => {
          state.methodVerifications = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getVehicleModelSelectDataByMakeId.matchFulfilled,
        (state, { payload }) => {
          state.vehicleModels = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getVehicleMakeSelectData.matchFulfilled,
        (state, { payload }) => {
          state.vehicleMakes = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getVehicleColorSelectData.matchFulfilled,
        (state, { payload }) => {
          state.vehicleColors = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getVehicleTypeSelectData.matchFulfilled,
        (state, { payload }) => {
          state.vehicleTypes = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getVehicleStatusSelectData.matchFulfilled,
        (state, { payload }) => {
          state.vehicleStatus = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getVehicleInspectionTypeSelectData.matchFulfilled,
        (state, { payload }) => {
          state.vehicleInspectionType = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getVehicleInspectionOrganizationSelectData
          .matchFulfilled,
        (state, { payload }) => {
          state.vehicleInspectionOrganization = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getVehicleInspectionDeterminationSelectData
          .matchFulfilled,
        (state, { payload }) => {
          state.vehicleInspectionDetermination = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getVehicleRegistrationIssuingAuthoritySelectData
          .matchFulfilled,
        (state, { payload }) => {
          state.vehicleRegistrationIssuingAuthority = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getVehiclePermitIssuingAuthoritySelectData
          .matchFulfilled,
        (state, { payload }) => {
          state.vehiclePermitIssuingAuthority = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getPersonnelIdentificationTypeSelectData
          .matchFulfilled,
        (state, { payload }) => {
          state.personnelIdentificationType = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getPersonnelIdentificationIssuingSelectData
          .matchFulfilled,
        (state, { payload }) => {
          state.personnelIdentificationIssuing = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getPersonnelCertificationsTypeSelectData
          .matchFulfilled,
        (state, { payload }) => {
          state.personnelCertificationType = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getPersonnelCertificationsIssuingSelectData
          .matchFulfilled,
        (state, { payload }) => {
          state.personnelCertificationIssuing = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getPersonnelScreeningsTypeSelectData
          .matchFulfilled,
        (state, { payload }) => {
          state.personnelScreeningType = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getPersonnelScreeningsIssuingSelectData
          .matchFulfilled,
        (state, { payload }) => {
          state.personnelScreeningsIssuing = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getPersonnelPermitTypeSelectData.matchFulfilled,
        (state, { payload }) => {
          state.personnelPermitType = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getPersonnelPermitIssuingSelectData.matchFulfilled,
        (state, { payload }) => {
          state.personnelPermitIssuing = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getContractorsTypeSelectData.matchFulfilled,
        (state, { payload }) => {
          state.contractorsType = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getContractorsAtmsSelectData.matchFulfilled,
        (state, { payload }) => {
          state.contractorsAtms = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getContractorsStatusSelectData.matchFulfilled,
        (state, { payload }) => {
          state.contractorsStatus = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getRelationshipSelectData.matchFulfilled,
        (state, { payload }) => {
          state.relationshipSelect = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getInsuranceTypeSelectData.matchFulfilled,
        (state, { payload }) => {
          state.insuranceType = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getInsuranceInsurerSelectData.matchFulfilled,
        (state, { payload }) => {
          state.insuranceInsurer = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getInsuranceBrokerSelectData.matchFulfilled,
        (state, { payload }) => {
          state.insuranceBroker = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getContractTypeSelectData.matchFulfilled,
        (state, { payload }) => {
          state.contractType = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getLicenseTypeSelectData.matchFulfilled,
        (state, { payload }) => {
          state.licenseType = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getPermitInsuranceTypeSelectData.matchFulfilled,
        (state, { payload }) => {
          state.permitInsuranceType = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getUserTypeSelectData.matchFulfilled,
        (state, { payload }) => {
          state.userType = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getSurveyTemplateSelectData.matchFulfilled,
        (state, { payload }) => {
          state.surveyTemplateSelect = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getPersonnelItemTypeSelectData.matchFulfilled,
        (state, { payload }) => {
          state.personnelItemTypeSelect = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getPersonnelItemStatusSelectData.matchFulfilled,
        (state, { payload }) => {
          state.personnelItemStatusSelect = payload;
        }
      )
      .addMatcher(
        membersApi.endpoints.getPreferenceAllTags.matchFulfilled,
        (state, { payload }) => {
          state.preferenceAllTags = payload;
        }
      )
      .addMatcher(
        membersApi.endpoints.getPreferenceSelectedTags.matchFulfilled,
        (state, { payload }) => {
          state.preferenceSelectedTags = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getPlacesLocationTypes.matchFulfilled,
        (state, { payload }) => {
          state.placesLocationTypes = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getLimitsTypes.matchFulfilled,
        (state, { payload }) => {
          state.limitsTypes = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getMemberInfoPriority.matchFulfilled,
        (state, { payload }) => {
          state.memberInfoPriority = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getVerificationMethods.matchFulfilled,
        (state, { payload }) => {
          state.verificationMethods = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getSendingMethods.matchFulfilled,
        (state, { payload }) => {
          state.sendingMethods = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getWarningMethods.matchFulfilled,
        (state, { payload }) => {
          state.warningMethods = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getContractors.matchFulfilled,
        (state, { payload }) => {
          state.contractors = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getLosContractors.matchFulfilled,
        (state, { payload }) => {
          state.lobContractors = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getActiveContractors.matchFulfilled,
        (state, { payload }) => {
          state.activeContractors = sortByLabelAsc<selectItemType>(payload);
        }
      )
      .addMatcher(
        selectsApi.endpoints.getPayerActiveContractors.matchFulfilled,
        (state, { payload }) => {
          state.activeContractorsV2 = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getActiveContractorsV2.matchFulfilled,
        (state, { payload }) => {
          state.activeContractorsV2 = sortByLabelAsc<selectItemType>(payload);
        }
      )
      .addMatcher(
        selectsApi.endpoints.getContractorsLos.matchFulfilled,
        (state, { payload }) => {
          state.contractorsLos = payload as any;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getServices.matchFulfilled,
        (state, { payload }) => {
          state.contractorServices = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getTimes.matchFulfilled,
        (state, { payload }) => {
          state.timeSelect = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getPlaceLocationsSelect.matchFulfilled,
        (state, { payload }) => {
          state.placeLocationsSelect = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getPayorSelect.matchFulfilled,
        (state, { payload }) => {
          state.payorSelectData = payload;
        }
      )
      .addMatcher(
        payorsApi.endpoints.getLevelOfService.matchFulfilled,
        (state, { payload }) => {
          state.levelOfServiceAdditional = getOrderedLosOptions(payload);
        }
      )
      .addMatcher(
        selectsApi.endpoints.getHealthPlanSelect.matchFulfilled,
        (state, { payload }) => {
          state.healthPlanSelectDate = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getUserTypeFiltrationSelect.matchFulfilled,
        (state, { payload }) => {
          state.userTypeFiltration = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getUserPermissionsFiltrationSelect.matchFulfilled,
        (state, { payload }) => {
          state.userPermissionsFiltration = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getPreferenceUsers.matchFulfilled,
        (state, { payload }) => {
          state.createdByFiltration = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getChangedByFiltrationSelect.matchFulfilled,
        (state, { payload }) => {
          state.changedByFiltration = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getViewedByFiltrationSelect.matchFulfilled,
        (state, { payload }) => {
          state.viewedByFiltration = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getNotedByFiltrationSelect.matchFulfilled,
        (state, { payload }) => {
          state.notedByFiltration = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getRideSegmentStatusSelect.matchFulfilled,
        (state, { payload }) => {
          state.rideSegmentStatus = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getRideSegmentStatusChangeSelect.matchFulfilled,
        (state, { payload }) => {
          state.rideSegmentStatusChange = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getReasonsByStatusSelect.matchFulfilled,
        (state, { payload }) => {
          state.statusReasons = payload;
        }
      )
      .addMatcher(
        authLoginApi.endpoints.getUserPermissionsTypeSelect.matchFulfilled,
        (state, { payload }) => {
          state.userPermissionsTypeSelect = payload;
        }
      )
      .addMatcher(
        authLoginApi.endpoints.getUserPermissionsSelect.matchFulfilled,
        (state, { payload }) => {
          state.userPermissionsSelect = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getContractorsLosAllType.matchFulfilled,
        (state, { payload }) => {
          state.contractorsLosAllType = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getActiveContractorsListForPreference
          .matchFulfilled,
        (state, { payload }) => {
          state.preferenceActiveContractors = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getPreferencesAssignmentType.matchFulfilled,
        (state, { payload }) => {
          state.preferenceAssignmentTypes = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getDashboardContractors.matchFulfilled,
        (state, { payload }) => {
          state.dashboardContractors = payload;
        }
      )
      .addMatcher(
        selectsApi.endpoints.getNotificationMethods.matchFulfilled,
        (state, { payload }) => {
          state.notificationMethods = payload;
        }
      );
  },
});

export const {
  setLevelOfServiceAdditional,
  setContractorServices,
  setActivityStatus,
} = selectsSlice.actions;
export const selectSelects = (state) => state.selects;
export const selectsReducer = selectsSlice.reducer;
